module.exports = __webpack_public_path__ + "0e1692f77ad2ba46e08472b8f8108a91.jpg";